import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../../public/styles/HomeInteriors/LocateUs/SelectedCity.scss";
import {
  GoogleMap,
  Marker,
  withScriptjs,
  withGoogleMap,
} from "react-google-maps";
import Geocode from "react-geocode";
import apiManager from "../../../utils/apiManager";
import { isMobile } from "../../../utils/utilityManager";
import {
  mapKey,
  imagePrefix,
  espotAPI,
  HIStoresAPI,
} from "../../../../public/constants/constants";
import FormBody from "../OrphanPage/FormBody";
const orangeIcon = `${imagePrefix}/B2C/static/store/orangeIcon.svg`;

export default class StoreSelected extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultLat: this.props.selectedStore.latitude,
      defaultLng: this.props.selectedStore.longitude,
      espotName: "GI_Interiors_LocateUs_StoreLocations",
      CitySlider: null, // City data for all cities
      selectedStore: this.props.selectedStore, // Complete data for only selected store
      storeMasterRegion: this.props.storeMaster, // Complete data for all the stores in the city
      cityData: this.props.cityData,  // City name, pincodes and region data
      selectedRegion: this.props.selectedStore.storeRegion,
      pincode: "",
      regions: [],
      selectedCity: this.props.cityData.city,
      
      showModal: false,
    };
  }

  closeModal = () => {
    this.setState({
      showModal: false,
    });
  };

  modalOpenHandler = () =>{
    this.setState({
      showModal: true,
    });
  }

  onCitySelect = e => {
    this.setState(
      {
        cityData: e,
        pincode: e.pincode,
        regions: e.regions,
        selectedCity: e.city,
        // defaultLat: store.latitude,
        // defaultLng: store.longitude,
        // selectedRegion: e.value,
        // selectedStore: store
      },
      () => {
        Geocode.setApiKey(mapKey);
        Geocode.fromAddress(this.state.pincode).then(
          response => {
            const { lat, lng } = response.results[0].geometry.location;
            this.getStoreData(lat, lng, e.city);
          },
          error => {}
        );
      }
    );
  };

  getStoreData(lat, lng, city) {
    const data = {
      params: {
        latitude: lat,
        longitude: lng,
        cityname: city,
      },
    };

    apiManager
      .get(`${HIStoresAPI}`, data)
      .then(response => {
        this.setState(
          {
            storeMasterRegion: response.data.data,
            isLoading: false,
            isOpen: false,
            isError: false,
            filteredSingleStore: null,
          },
          () => {
            this.setData();
          }
        );
     
      })
      .catch(error => {

        this.setState({
          selectedStore: null,
          isLoading: false,
          searchStoreType: "city",
          isError: true,
          filteredSingleStore: null,
        });
      });
  }

  setData() {
    this.state.CitySlider.forEach((city, key) => {
      if (city.city.toLowerCase() == this.state.selectedCity.toLowerCase()) {
        this.setState({
          regions: city.regions,
          cityData: city,
          selectedRegion: city.regions[0],
        }, ()=>{
          this.state.storeMasterRegion.forEach(store => {
            if (store.storeRegion == this.state.selectedRegion) {
              this.setState({
                defaultLat: store.latitude,
                defaultLng: store.longitude,
                selectedStore: store,
              });
            }
          });
        
        });
        
      }
    });
    // this.state.storeMasterRegion.map((store,key)=>(

    // ))
  }

  getDistance(lat1, lon1, lat2, lon2) {
    const inKm = 6371; // km
    const dLat = this.toRadius(lat2 - lat1);
    const dLon = this.toRadius(lon2 - lon1);
    const getLat1 = this.toRadius(lat1);
    const getLat2 = this.toRadius(lat2);

    let getValueInKm =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) *
        Math.sin(dLon / 2) *
        Math.cos(getLat1) *
        Math.cos(getLat2);
    getValueInKm =
      2 * Math.atan2(Math.sqrt(getValueInKm), Math.sqrt(1 - getValueInKm));
    getValueInKm = inKm * getValueInKm;
    return getValueInKm.toFixed(1);
  }

  createMap(storeData) {
    const defaultMapOptions = {
      fullscreenControl: false,
    };
    return (
      <GoogleMap
        defaultZoom={10}
        defaultCenter={{
          lat: parseFloat(this.state.defaultLat),
          lng: parseFloat(this.state.defaultLng),
        }}
        defaultOptions={defaultMapOptions}
      >
        {storeData.map((item, index) => {
          const data = this.getDistance(
            this.state.defaultLat,
            this.state.defaultLng,
            item.latitude,
            item.longitude
          );
          let iconType = orangeIcon;
          const siwRef = React.createRef();
          if (item.storeName === "Godrej Interio Store") {
            iconType = blueIcon;
          }
          return (
            <div key={index}>
              <Marker
                onClick={() => this.handleToggleOpen(index, siwRef)}
                position={{
                  lat: parseFloat(item.latitude),
                  lng: parseFloat(item.longitude),
                }}
                icon={{
                  url: iconType,
                }}
              />
            </div>
          );
        })}
      </GoogleMap>
    );
  }

  handleToggleOpen = (index, siwRef) => {
    siwRef.current.openWindow();
    if (this.lastOpenWindow != null) {
      this.lastOpenWindow.current.onCloseWindow();
    }
    if (this.lastIndex == index) {
      this.lastOpenWindow = null;
      this.lastIndex = -1;
    } else {
      this.lastOpenWindow = siwRef;
      this.lastIndex = index;
    }

    // this.setState({
    //     isOpen: true,
    //     Infokey: index
    // });
  };

  onCheckboxSelect = e => {
    this.state.storeMasterRegion.forEach(store => {
      console.log(`${store.storeRegion  } ${  e.target.value}`)
      if (store.storeRegion == e.target.value) {
        // alert("working");
        this.setState({
          defaultLat: store.latitude,
          defaultLng: store.longitude,
          selectedRegion: e.target.value,
          selectedStore: store,
        });
      }
    });
  };

  onLoadSetStore(e) {
    // alert(e);
    this.state.storeMasterRegion.forEach(store => {
      if (store.storeRegion == e.target.value) {
        this.setState({
          defaultLat: store.latitude,
          defaultLng: store.longitude,
          selectedRegion: e.target.value,
          selectedStore: store,
        });
      }
    });
  }

  getEspotData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const { data } = response || {};
        this.setState({
          CitySlider: data.data && data.data.data,
        });
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  }

  componentDidMount() {
    this.getEspotData();
  }

  toRadius(Value) {
    return (Value * Math.PI) / 180;
  }

  render() {
    const { CitySlider } = this.state;
    const { cityData } = this.state;
    const { selectedStore } = this.state;
    let WrappedMap;
    const mapData = [];
    mapData.push(selectedStore);
    WrappedMap = withScriptjs(
      withGoogleMap(this.createMap.bind(this, mapData))
    );
    const settings = {
      slidesToShow: isMobile() ? 3 : 5,
      slidesToScroll: 1,
      autoplay: false,
      focusOnSelect: false,
      dontAnimate: true,
      arrows: true,
      dots: false,
      prevArrow: <button className="slide-arrow prev-arrow" />,
      nextArrow: <button className="slide-arrow next-arrow" />,
      infinite: false,
    };
    const settingsRegions = {
      slidesToShow: this.state.cityData.regions.length,
      slidesToScroll: 1,
      autoplay: false,
      focusOnSelect: true,
      dontAnimate: true,
      arrows: !!isMobile(),
      dots: false,
    };
    const ImgsSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      focusOnSelect: true,
      dontAnimate: true,
      arrows: !!isMobile(),
      dots: true,
    };

    return (
      <div className="filter-store">
        <div className="filternav">
          <h3>Our studios - Experiance centers</h3>
          <div className="filternav-container">
            <div className="filternav-wrapper">
              {isMobile() ? (
                <></>
              ) : (
                <div className="filternav-city">
                  <h4>CITY</h4>
                </div>
              )}

              <div className="filternav-citynames">
                <Slider {...settings} ref={slider => (this.slider = slider)}>
                  {!!CitySlider &&
                    CitySlider.map((sliderData, index) => (
                      <div
                        className={
                          sliderData.city == this.state.selectedCity
                            ? "filternav-cityname-active filternav-cityname"
                            : "filternav-cityname"
                        }
                        onClick={this.onCitySelect.bind(this, sliderData)}
                      >
                        <h4>
                          <a>{sliderData.city}</a>
                        </h4>
                      </div>
                      
                    ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
        <div className="filter-region-container">
          <div className="filter-region-wrapper">
            <div className="filternav-container">
              <div className="filternav-wrapper">
                {isMobile() ? (
                  <></>
                ) : (
                  <div
                    className="filternav-city"
                    onLoad={() => {
                      this.onLoadSetStore.bind(this, this.state.selectedRegion);
                    }}
                  >
                    <img src={imagePrefix + this.state.cityData.icon} />
                  </div>
                )}

                <div className="filternav-citynames">
                  <Slider
                    {...settingsRegions}
                    ref={slider => (this.slider = slider)}
                  >
                    {!!cityData &&
                      cityData.regions.map((sliderData, index) => (
                        <div className="filternav-cityname">
                          <h4>
                            <input
                              type="radio"
                              name="region"
                              id={sliderData}
                              value={sliderData}
                              checked={
                                sliderData == this.state.selectedRegion
                              }
                              onChange={this.onCheckboxSelect.bind(this)}
                            />
                            <label htmlFor={sliderData}>{sliderData}</label>
                          </h4>
                        </div>
                      ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="storedata-container">
          <div className="storedata-wrapper">
            {this.state.selectedRegion != "" ? (
              <div className="store-container">
                {!!this.state.storeMasterRegion &&
                  this.state.storeMasterRegion.map(
                    (store, key) =>
                      store.storeRegion == this.state.selectedRegion && (
                        <div className=" store-inner-wrapper">
                          <div className="store-wrapper">
                            <div className="storeimg-container">
                              <Slider
                                {...ImgsSettings}
                              > 
                                {store.storeImg.map((img,key)=>(<div className="storeimg-wrapper">
                     
                                  <img
                                    src={
                                      imagePrefix + store.storeImgPath +
                        img
                                    }
                                  />
                                </div>))}
                              </Slider>
                              
                            </div>
                            <div className="storemapMain-container">
                              <div
                                className="storemap-container"
                                id="mapContainer"
                              >
                                <WrappedMap
                                  googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${mapKey}`}
                                  loadingElement={
                                    <div
                                      style={{
                                        height: isMobile() ? "35vh" : "100%",
                                      }}
                                    />
                                  }
                                  containerElement={
                                    <div
                                      style={{
                                        height: isMobile() ? "35vh" : "100%",
                                      }}
                                    />
                                  }
                                  mapElement={
                                    <div
                                      style={{
                                        height: isMobile() ? "35vh" : "100%",
                                      }}
                                    />
                                  }
                                />
                              </div>
                            </div>{" "}
                          </div>

                          <div className="storedetails-footer">
                            <div className="storedata">
                              <h3>{store.storeTitle}</h3>
                              <span>
                                {`${store.address1  } ${  store.address2  } - ${  store.pinCode}`}
                              </span>
                            </div>
                            <div className="storeDetails-container">
                              <div className="storeDetails-wrapper">
                                <div className="storeDetails-top">
                                  <div className="storeDetailBox">
                                    <img
                                      src={
                                        `${imagePrefix 
                                        }/B2C/homeinteriors/LocateUs/Clock.svg`
                                      }
                                    />
                                    <span>
                                      {store.storeHours.split(" : ")[0]}
                                    </span>
                                  </div>
                                  <div className="storeDetailBox">
                                    <img
                                      src={
                                        `${imagePrefix 
                                        }/B2C/homeinteriors/LocateUs/calendar.svg`
                                      }
                                    />
                                    <span>
                                      {store.storeHours.split(" : ")[1]}
                                    </span>
                                  </div>
                                  <div className="storeDetailBox">
                                    <img
                                      src={
                                        `${imagePrefix 
                                        }/B2C/homeinteriors/LocateUs/phoneCall.svg`
                                      }
                                    />
                                    <span>{store.telephone}</span>
                                  </div>
                                </div>
                                <hr />
                                <div className="store-footer">
                                  <button onClick={this.modalOpenHandler.bind(this)}>Book a Visit</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        {this.state.showModal ? (
          <>
            <FormBody
              // class="modal-orphan-form"
              source
              pageSource = "HI_LocateUs"
              closeModal={this.closeModal.bind(this)}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}
